import React from "react";
import { motion } from "framer-motion";
import SlideOverlay from "./SlideOverlay";

const SlidePerformance = React.memo(function SlidePerformance() {
  return (
    <>
      {/* Background Layer */}
      <div
        className="absolute inset-0 bg-cover bg-center transition-opacity duration-1000"
        style={{
          backgroundImage: `url(./carousel_img/performancebg.webp)`,
          backgroundColor: "#1e1e21",
          willChange: "transform",
          contain: "layout style paint",
        }}
      >
        <img
          src="./carousel_img/performancebg.webp"
          alt=""
          className="hidden"
          fetchPriority="high"
          loading="eager"
          decoding="async"
        />
        <div className="absolute inset-0" />
      </div>

      <SlideOverlay
        label="Unleash Your Competitive Edge"
        title="Performance at Scale"
        description="Transform your business with our enterprise-grade solutions, delivering up to 10x faster decision-making and automated intelligence"
        ctaText="Explore Solutions"
        ctaUrl="/services"
      >
        <motion.img
          src="./carousel_img/performance.webp"
          alt="Performance at Scale visualization"
          width={940}
          height={600}
          initial={{ x: 100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ delay: 1.4, duration: 0.25 }}
          className="absolute bottom-[190px] right-0 w-[940px] h-auto pointer-events-none z-10"
          loading="lazy"
          decoding="async"
        />
      </SlideOverlay>
    </>
  );
});

export default SlidePerformance;

